import { useEffect } from "react";

const SITE_NAME = "Explorio";
const SITE_URL = "https://explorio.earth";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const DEFAULT_TITLE = "Explorio - Free AI Trip Planner & Travel Organizer App";
const DEFAULT_DESCRIPTION =
  "Plan your next trip with AI. Free travel planner with itinerary generator, visa checker for 199 countries, packing lists, budget tracker, travel journal, and more.";

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "",
  type = "website",
  jsonLd,
}) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const url = `${SITE_URL}${path}`;

  useEffect(() => {
    document.title = pageTitle;

    setMeta("name", "description", description);
    setLink("canonical", url);

    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:title", pageTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", DEFAULT_IMAGE);
    setMeta("property", "og:site_name", SITE_NAME);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", pageTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", DEFAULT_IMAGE);

    // JSON-LD
    const existingLd = document.querySelector('script[data-seo-jsonld]');
    if (jsonLd) {
      if (existingLd) {
        existingLd.textContent = JSON.stringify(jsonLd);
      } else {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-seo-jsonld", "true");
        script.textContent = JSON.stringify(jsonLd);
        document.head.appendChild(script);
      }
    } else if (existingLd) {
      existingLd.remove();
    }
  }, [pageTitle, description, url, type, jsonLd]);

  return null;
};
